export enum ApplicantStatusEnum {
    Enquiry = 0,
    PendingRegistration = 1,
    Registered = 2,
    ApplicationInProgress = 3,
    FormAndReportSubmitted = 4,
    ApplicationUnderReview = 5,
    AmendmentsRequired = 6,
    ApplicationRejected = 7,
    ApplicationAccepted = 8,
    PendingReservationFee = 9,
    ReservationFeePaid = 10,
    AwaitingSupportingInfo = 11,
    SupportingInfoSubmitted = 12,
}
